import { cn as e } from "../../lib/utils.es.js";
import { Button as t } from "../ui/button.es.js";
import { Popover as n, PopoverContent as r, PopoverTrigger as i } from "../ui/popover.es.js";
import { Label as a } from "../ui/label.es.js";
import { Calendar as o } from "../ui/calendar.es.js";
import { TimePicker as s } from "../TimePicker/TimePicker.es.js";
import { useState as c } from "react";
import { CalendarIcon as l } from "lucide-react";
import { jsx as u, jsxs as d } from "react/jsx-runtime";
import { endOfDay as f, format as p, startOfDay as m, subDays as h, subHours as g } from "date-fns";
// libs/ui-lib/src/components/DateRangePicker/DateRangePicker.tsx
var _ = {
	label: "Today",
	getRange: () => ({
		from: m(/* @__PURE__ */ new Date()),
		to: /* @__PURE__ */ new Date()
	})
}, v = {
	label: "Yesterday",
	getRange: () => {
		let e = h(/* @__PURE__ */ new Date(), 1);
		return {
			from: m(e),
			to: f(e)
		};
	}
};
function y(e) {
	return {
		label: `Last ${e} ${e === 1 ? "hour" : "hours"}`,
		getRange: () => {
			let t = /* @__PURE__ */ new Date();
			return {
				from: g(t, e),
				to: t
			};
		}
	};
}
function b(e) {
	return {
		label: `Last ${e} days`,
		getRange: () => ({
			from: m(h(/* @__PURE__ */ new Date(), e - 1)),
			to: /* @__PURE__ */ new Date()
		})
	};
}
var x = [
	_,
	v,
	b(7),
	b(14),
	b(30)
];
function S(e, t, n) {
	let r = new Date(e);
	return t ? r.setHours(t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()) : n ? r.setHours(23, 59, 59, 999) : r.setHours(0, 0, 0, 0), r;
}
function C({ label: e, value: t, onChange: n, dataTestId: r }) {
	return /* @__PURE__ */ d("div", {
		className: "flex flex-1 items-center gap-2",
		children: [/* @__PURE__ */ u(a, {
			className: "text-muted-foreground text-xs",
			children: e
		}), /* @__PURE__ */ u(s, {
			value: t,
			onChange: n,
			dataTestId: r
		})]
	});
}
function w({ value: a, onChange: s, presets: f = x, showTime: m = !1, placeholder: h = "Pick a date range", minDate: g, maxDate: _, numberOfMonths: v = 2, disabled: y = !1, align: b = "start", id: w, className: T, dataTestId: E = "date-range-picker" }) {
	let [D, O] = c(!1), [k, A] = c(void 0), [j, M] = c(void 0), N = k ?? a, P = j ?? a, F = (e) => m ? p(e, "MMM d, yyyy, h:mm a") : p(e, "MMM d, yyyy"), I = a ? `${F(a.from)} – ${F(a.to)}` : h, L = !k?.from || !k?.to, R = () => {
		k?.from && k?.to && (s?.({
			from: S(k.from, j?.from ?? a?.from, !1),
			to: S(k.to, j?.to ?? a?.to, !0)
		}), A(void 0), M(void 0), O(!1));
	}, z = () => {
		A(void 0), M(void 0), O(!1);
	};
	return /* @__PURE__ */ d(n, {
		open: D,
		onOpenChange: (e) => {
			O(e), A(void 0), M(void 0);
		},
		children: [/* @__PURE__ */ u(i, {
			asChild: !0,
			children: /* @__PURE__ */ d(t, {
				id: w,
				variant: "outline",
				disabled: y,
				"data-testid": E,
				className: e("h-9 min-w-0 justify-between gap-2 px-3 font-normal", !a && "text-muted-foreground", T),
				children: [/* @__PURE__ */ u("span", {
					className: "truncate",
					children: I
				}), /* @__PURE__ */ u(l, { className: "size-4 shrink-0 text-muted-foreground" })]
			})
		}), /* @__PURE__ */ d(r, {
			className: "flex max-h-[var(--radix-popover-content-available-height)] w-auto flex-col overflow-hidden p-0",
			align: b,
			children: [/* @__PURE__ */ d("div", {
				className: "flex min-h-0 overflow-y-auto",
				children: [f.length > 0 ? /* @__PURE__ */ u("div", {
					className: "flex flex-col gap-0.5 border-border border-r p-2",
					children: f.map((e) => /* @__PURE__ */ u(t, {
						variant: "ghost",
						size: "sm",
						className: "justify-start font-normal",
						"data-testid": `${E}--preset-${e.label.toLowerCase().replace(/\s+/g, "-")}`,
						onClick: () => {
							let t = e.getRange();
							A(t), M(t);
						},
						children: e.label
					}, e.label))
				}) : null, /* @__PURE__ */ d("div", { children: [/* @__PURE__ */ u(o, {
					mode: "range",
					selected: N,
					defaultMonth: N?.from,
					numberOfMonths: v,
					captionLayout: "dropdown",
					startMonth: g,
					endMonth: _,
					classNames: { months: "relative flex flex-row gap-4" },
					disabled: [...g ? [{ before: g }] : [], ..._ ? [{ after: _ }] : []],
					onSelect: (e) => {
						A(e), e?.from && e?.to && M({
							from: S(e.from, j?.from ?? a?.from, !1),
							to: S(e.to, j?.to ?? a?.to, !0)
						});
					}
				}), m && P ? /* @__PURE__ */ d("div", {
					className: "flex items-center gap-4 border-border border-t p-3",
					children: [/* @__PURE__ */ u(C, {
						label: "From",
						value: P.from,
						dataTestId: `${E}--time-from`,
						onChange: (e) => M({
							from: e,
							to: P.to
						})
					}), /* @__PURE__ */ u(C, {
						label: "To",
						value: P.to,
						dataTestId: `${E}--time-to`,
						onChange: (e) => M({
							from: P.from,
							to: e
						})
					})]
				}) : null] })]
			}), /* @__PURE__ */ d("div", {
				className: "flex shrink-0 justify-end gap-2 border-border border-t p-2",
				children: [/* @__PURE__ */ u(t, {
					variant: "default",
					size: "sm",
					"data-testid": `${E}--apply`,
					disabled: L,
					onClick: R,
					children: "Apply"
				}), /* @__PURE__ */ u(t, {
					variant: "outline",
					size: "sm",
					"data-testid": `${E}--cancel`,
					onClick: z,
					children: "Cancel"
				})]
			})]
		})]
	});
}
export { x as DEFAULT_DATE_RANGE_PRESETS, w as DateRangePicker, _ as TODAY_PRESET, v as YESTERDAY_PRESET, b as lastDaysPreset, y as lastHoursPreset };
